module.exports = __webpack_public_path__ + "static/img/Contact.d81ca61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact.png
// module id = QCTk
// module chunks = 0